"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();
import { useTranslations } from "next-intl";
import { useState } from "react";
import ClickOutsideHandler from "@/components/ClickOutsideHandler";
import { type Locale, visibleLocales } from "@/i18n/routing";
import { useLocale } from "@/providers/LocaleProvider/index.client";
import "./locale-switcher-select.scss";

export default function LocaleSwitcherSelect() {
	const t = useTranslations("LocaleSwitcher");
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const { locale: defaultValue, onLocaleSelect } = useLocale();

	return (
		<ClickOutsideHandler onClickOutside={() => setIsOpen(false)}>
			<div className="locale-switcher-select">
				<p className="sr-only">{t("locale", { locale: defaultValue })}</p>
				<button
					aria-label="Select language"
					aria-haspopup="true"
					aria-expanded={isOpen}
					type="button"
					onClick={() => setIsOpen(!isOpen)}
					className="locale-switcher-select__button"
				>
					<span>{t("locale", { locale: defaultValue })}</span>
					<span className="arrow-down">⌄</span>
				</button>
				{isOpen && (
					<div
						aria-label="Select language"
						className="locale-switcher-select__dropdown"
					>
						<ul role="menu">
							{visibleLocales.map((cur) => (
								<li
									key={cur}
									onClick={() => onLocaleSelect(cur as Locale)}
									className="locale-switcher-select__option"
								>
									{t("locale", { locale: cur })}
								</li>
							))}
						</ul>
					</div>
				)}
			</div>
		</ClickOutsideHandler>
	);
}
